import React from "react";
import "../styles/loading_component.css";
import { ThreeDots } from "react-loader-spinner";
import logo from "./logomain.png";

const LoadingPopup = (props) => {
  return (
    <>
      <div id={props.id} className="mainContainerLoadingPopup">
        <div className="rowLoadingPopup">
          {props.login === 0 ? (
            <div className="flexbox_loading">
              <img
                className="logoLoading"
                src={
                  "https://ftpeople.pl/wp-content/uploads/2023/06/logomain.png"
                }
              />
            </div>
          ) : (
            ""
          )}
          <div className="loaderBoxLoadingPopup" style={{ flexWrap: "wrap" }}>
            {props.loading2 ? (
              <div
                style={{
                  width: "100%",
                  textAlign: "center",
                  fontSize: "2vw",
                  fontWeight: "600",
                }}
              >
                {props.loadingTxt}
              </div>
            ) : (
              ""
            )}
            <ThreeDots color="black" height={100} width={100} />
            <div>{props.textLoading}</div>
          </div>
          {props.login !== 1 ? (
            <span className="loadingTextLoadingPopup"></span>
          ) : (
            ""
          )}
        </div>
      </div>
    </>
  );
};

export default LoadingPopup;
